import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
const Footer = () => {
    const { t } = useTranslation();
    return (
        <div>
            <section className="fixed w-full shadow-md bg-[#004040] p-4 bottom-0 text-white lg:hidden z-10">
                <ul className='flex justify-around gap-4'>
                    <li>
                        <Link className='flex items-center flex-col' to={'/'}>
                            <span className="material-symbols-outlined">
                                home
                            </span>
                            <h1 className='text-sm font-semibold text-slate-300'>{t('home')}</h1>
                        </Link>
                    </li>
                    <li>
                        <Link className='flex items-center flex-col' to={'/shop'}>
                            <span className="material-symbols-outlined">
                                shopping_bag
                            </span>
                            <h1 className='text-sm font-semibold text-slate-300'>{t('shop')}</h1>
                        </Link>
                    </li>
                    <li>
                        <Link className='flex items-center flex-col' to={'/categories'}>
                            <span className="material-symbols-outlined">
                                category
                            </span>
                            <h1 className='text-sm font-semibold text-slate-300'>{t('categories')}</h1>
                        </Link>
                    </li>
                    <li>
                        <Link className='flex items-center flex-col' to={'brands'}>
                            <span className="material-symbols-outlined">
                                award_star
                            </span>
                            <h1 className='text-sm font-semibold text-slate-300'>{t('brands')}</h1>
                        </Link>
                    </li>

                    <li>
                        <Link className='flex items-center flex-col' to={'/shop/top-selling'}>
                            <span className="material-symbols-outlined">
                                sell
                            </span>
                            <h1 className='text-sm font-semibold text-slate-300'>{t('top_selling')}</h1>
                        </Link>
                    </li>
                </ul>

            </section>
            <section className='hidden lg:block' >
                <div className='footer'>
                    <div className=""
                        style={{
                            backgroundColor: "#004040",
                            color: '#FFF'

                        }}
                    >
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-1 p-8">
                            <div>
                                <h4 className='pb-3 text-xl'><strong>{t('quick_links')}</strong></h4>
                                <ul className=''>
                                    <li className='mb-2'>
                                        <Link to="/cart">{t('cart')}</Link>
                                    </li>
                                    <li className='mb-2'>
                                        <Link to="/login">{t('login')}</Link>
                                    </li>
                                    <li className='mb-2'>
                                        <Link to='/register' >{t('register')}</Link>
                                    </li>
                                    <li className='mb-2'>
                                        <Link >{t('wishlist')}</Link>
                                    </li>
                                    <li className='mb-2'>
                                        <Link >{t('track_order')}</Link>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h4 className='pb-3 text-xl'><strong>{t('shop_more')}</strong></h4>
                                <ul className=''>
                                    <li className='mb-2'>
                                        <Link to="/shop/top-rated">{t('top_rated_products')}</Link>
                                    </li>
                                    <li className='mb-2'>
                                        <Link to="shop/top-selling">{t('best_sellers')}</Link>
                                    </li>
                                    <li className='mb-2'>
                                        <Link to={'/brands'}>{t('shop_by_brands')}</Link>
                                    </li>
                                    <li className='mb-2'>
                                        <Link to='/collections'>{t('collections')}</Link>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h4 className='pb-3 text-xl'><strong>{t('return_policy')}</strong></h4>
                                <h6>{t('return_policy_text')}</h6>
                                <div className="py-4">
                                    <h4 className='pb-3 text-xl'><strong>{t('follow_us_on')}</strong></h4>
                                    <ul className='flex flex-wrap opacity-90'>
                                        <li className='mx-1'>
                                            <a target='_blank' href=''>
                                                <img src='/icons/instagram.png' alt="" width={36} />
                                            </a>
                                        </li>
                                        <li className='mx-1'>
                                            <a target='_blank' href=''>
                                                <img src='/icons/whatsapp.png' alt="" width={36} />
                                            </a>
                                        </li>
                                        <li className='mx-1'>
                                            <a target='_blank' href=''>
                                                <img src='/icons/facebook.png' alt="" width={36} />
                                            </a>
                                        </li>
                                        <li className='mx-1'>
                                            <a target='_blank' href=''>
                                                <img src='/icons/tik-tok.png' alt="" width={36} />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div>
                                <img src='/img/logo-footer.png' className='w-30' />
                                <p className='py-3 text-md'>Adasatee is an online store specializing in premium contact lenses. It offers a wide range of products from various brands, catering to customers in the GCC region.</p>
                            </div>
                        </div>
                        <div className='bg-[#5B5B5B] pb-6'>
                            <ul className='pt-8 pb-3 flex justify-center-safe flex-wrap '>
                                <li>
                                    <Link className='mx-2'>{t('faq')}</Link>
                                </li>
                                <li>
                                    <Link className='mx-2'>{t('privacy_policy')}</Link>
                                </li>
                                <li>
                                    <Link className='mx-2'>{t('return_policy')}</Link>
                                </li>
                                <li>
                                    <Link className='mx-2'>{t('contact_us')}</Link>
                                </li>
                                <li>
                                    <Link className='mx-2'>{t('about_us')}</Link>
                                </li>
                            </ul>
                            <h6 className='text-center'>{new Date().getFullYear()} | All Rights Reserved | ADASATEE</h6>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
}
export default Footer;